export default "__VITE_ASSET__0t5gyCwk__"